
import { Moon, Sun } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTheme } from "@/contexts/ThemeContext";

const ThemeToggle = () => {
  const { isDark, toggleTheme } = useTheme();

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={toggleTheme}
      className="relative hover:bg-accent transition-colors duration-200 border border-border/50"
      aria-label="Toggle theme"
    >
      <Sun className={`h-5 w-5 transition-all duration-300 ${isDark ? 'scale-0 rotate-90' : 'scale-100 rotate-0'} absolute`} />
      <Moon className={`h-5 w-5 transition-all duration-300 ${isDark ? 'scale-100 rotate-0' : 'scale-0 -rotate-90'} absolute`} />
    </Button>
  );
};

export default ThemeToggle;
